import {Inject, Injectable} from "@angular/core";
import { AppVersion } from "@ionic-native/app-version";
import { ConfigParameterApi } from '../sdk';
import { IsDebug } from "@ionic-native/is-debug";
import { AlertController, Platform } from "ionic-angular";
import { Market } from '@ionic-native/market';
import {ServerProvider} from "./server-provider";
import {EnvVariables} from "../../envioronment-variables/environment-variables.token";


@Injectable()
export class AutoupdateProvider {

    constructor(
        private appVersion: AppVersion,
        private configParameterService: ConfigParameterApi,
        private isDebug: IsDebug,
        private alertCtrl: AlertController,
        private platform: Platform,
        private market: Market,
        @Inject(EnvVariables) public envVariables
    ) {

    }

    /**
     * Comprueba la ultima versión minima de la app necesaria
     * 
     * En ODO está en configuración -> personalizacion -> objecto de bajo nivel -> system parameters -> appler.version
     */
    public ckeckMinVersionApp(){
        this.configParameterService.get_param('appler.version', ServerProvider.getCustomHeaders).toPromise().then(versionCloud => {
            console.log("version cloud", versionCloud);

            this.appVersion.getVersionCode().then(versionLocal => {
                console.log("version local", versionLocal);

                if(versionCloud > versionLocal){

                    this.isDebug.getIsDebug().then(isDebug => {
                        this.showMessageUpdateApp(isDebug);
                    }).catch(error => {
                        this.showMessageUpdateApp(true);
                    });
                }
                

            }).catch(error => {
                console.log("error version local", error);
            })

        }).catch(error => {
            console.log("error version cloud", error);
        });

    }

    private showMessageUpdateApp(isDebug:boolean){
        let alert = this.alertCtrl.create({
            title: "Actualización disponible",
            subTitle: "Hay disponible una nueva versión de la aplicación",
            buttons: [
                {
                    text: isDebug ? "Cerrar" : "Actualizar",
                    handler: () => {
                        if(!isDebug){
                            
                            this.market.open(this.envVariables.appPlayStoreId).then(success => {
                                this.platform.exitApp();
                            });
                        }else{
                            this.platform.exitApp();
                        }
                        
                    }
                }
            ]
        });

        alert.present();

    }

    
}


// WEBPACK FOOTER //
// ./src/providers/autoupdate-provider.ts